<form [formGroup]="form" autoTrackUnsavedChanges>
  <div class="vdp-offers">
    <div class="tab-panel-input-wrapper">
      <div class="field-input-label tab-input-label label-field">
        <label for="vdpOfferWidgetEnabled">VDP Offer Widget
          <i class="pi pi-info-circle"
             pTooltip="When enabled, MPOP Offer data and CTA will be displayed on dealer VDP pages when the data is matched by VIN."
             tooltipPosition="top"></i></label>
      </div>
      <div class="field-switch-label">
        <p-inputSwitch
          id="vdpOfferWidgetEnabled"
          formControlName="vdpOfferWidgetEnabled">
        </p-inputSwitch>
      </div>
    </div>
  </div>
</form>
